<ion-item
  mode="md"
  class="phone"
  lines="none"
  [ngClass]="{
    'phone--parent': contact.type === 'PARENT',
    'phone--child': contact.type === 'CHILD'
  }"
  [button]="urlHelper.isCallable && contact.type !== 'PARENT'"
  (click)="urlHelper.openPhone(contact.phone)"
>
  <div class="phone__inner">
    <div class="phone__image">
      <img
        *ngIf="contact.type !== 'CHILD'"
        [src]="'assets/images/contacts/' + contact.image"
        alt="Producto"
      />
    </div>
    <div class="phone__content">
      <div class="phone__content-texts mapfre-fs-xs-r">
        <div class="phone__title">{{ contact.title }}</div>
        <div>{{ contact.phone }}</div>
      </div>
      <div
        *ngIf="contact.type !== 'PARENT' && urlHelper.isCallable"
        class="phone__icon mapfre-hide-tablet-desktop"
      >
        <img src="assets/images/contacts/call.svg" alt="Teléfono" />
      </div>
    </div>
  </div>
</ion-item>
